module.exports = __webpack_public_path__ + "static/media/Vanillish_gaussian2.8d0e96bb.png";